import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class config_ai_template extends vnTemplate {




    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected getTemplateHtml(): string {
        return `
        <div class="w-form w-form-large">

            <div class="form-header">
            <h3 class="form-title icon i-ai">Ai Config</h3>
            </div>

            <div class="w-form-body">

            <div class="form-body">

            <strong class="form-sub-title parent"> personalities</strong>
            <div class="form-group">
            <label for="factualSummaryPersonality" class="form-label">factual Summary Personality</label>
            <textarea class="input-text" type="text" data-bind="value: factualSummaryPersonality" id="factualSummaryPersonality" style="flex:8;"></textarea>
            </div>
            <div class="form-group">
            <label for="satiricalSummaryPersonality" class="form-label">LightHearted Summary Personality</label>
            <textarea class="input-text" type="text" data-bind="value: satiricalSummaryPersonality" id="satiricalSummaryPersonality" style="flex:8;"></textarea>
            </div>
            <div class="form-group">
            <label for="simpleSummaryPersonality" class="form-label">Simple Summary Personality</label>
            <textarea class="input-text" type="text" data-bind="value: simpleSummaryPersonality" id="simpleSummaryPersonality" style="flex:8;"></textarea>
            </div>

            <strong class="form-sub-title parent">Brand Context</strong>
            <div class="form-group">
            <label for="brandContext" class="form-label">Brand Context</label>
            <textarea class="input-text" type="text" data-bind="value: brandContext" id="brandContext" style="flex:8;"></textarea>
            </div>

            <strong class="form-sub-title parent">Prompts</strong>
            <div class="form-group">
            <label for="summaryPrompt" class="form-label">Summary Prompt</label>
            <textarea class="input-text" type="text" data-bind="value: summaryPrompt" id="summaryPrompt" style="flex:8;"></textarea>
            </div>

                <strong class="form-sub-title parent">Article to test </strong>
            <div class="form-group">
            <label for="summaryPrompt" class="form-label">Article ID </label>
            <textarea class="input-text" type="text" data-bind="value: articleID" id="articleID" style="flex:8;"></textarea>
            </div>

            </div>
            </div>

            <div id="ai-summaries-container">

            </div>

            <div class="form-footer">
            <button data-bind="event: {click: onClickCancelAiSettings}" class="btn " type="button">Cancel</button>
            <button data-bind="event: {click: onClickSaveAiSettings}" class="btn highlight" type="button">Save</button>
            </div>
        </div>
         `;
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            simpleSummaryPersonality: ko.observable(""),
            factualSummaryPersonality: ko.observable(""),
            satiricalSummaryPersonality: ko.observable(""),
            brandContext: ko.observable(""),
            summaryPrompt: ko.observable(""),
            articleID: ko.observable(""),
            onClickCancelAiSettings: function (data, event) {
                self.onClickCancelAiSettings();
            },
            onClickSaveAiSettings: function (data, param, event) {
                self.onClickSaveAiSettings();
            }
        }
    }

    protected initPartial(): void {


    }


    protected getTemplateName(): string {
        return "config_ai_template";
    }

    public getAiSettings() {

        return {
            simpleSummaryPersonality: this.getTemplateViewModel().simpleSummaryPersonality(),
            factualSummaryPersonality: this.getTemplateViewModel().factualSummaryPersonality(),
            satiricalSummaryPersonality: this.getTemplateViewModel().satiricalSummaryPersonality(),
            brandContext: this.getTemplateViewModel().brandContext(),
            summaryPrompt: this.getTemplateViewModel().summaryPrompt(),
            articleID: this.getTemplateViewModel().articleID()
        }
    }



    protected onClickSaveAiSettings(): any {

        this.caller.saveAiSettings();
    }

    protected onClickCancelAiSettings(): any {
        this.caller.cancelSiteSettings()
    }

    public setAiSettings(data: any) {
        this.getTemplateViewModel().simpleSummaryPersonality(data.simpleSummaryPersonality);
        this.getTemplateViewModel().factualSummaryPersonality(data.factualSummaryPersonality);
        this.getTemplateViewModel().satiricalSummaryPersonality(data.satiricalSummaryPersonality);
        this.getTemplateViewModel().brandContext(data.brandContext);
        this.getTemplateViewModel().summaryPrompt(data.summaryPrompt);
        this.getTemplateViewModel().articleID(data.articleID);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/config_ai_template.ts